export * from './avatar.component'
